import React, { useEffect, useState } from 'react';
import { FOOTER_DATA_IRCTC, IRCTC_EXTERNAL_JS } from '../../utils/RailsSEOConstants';
import { trackLanguageSwitch } from '../../utils/omnitureUtils';
import {
  RAILS_LANDING_FAQ,
  productFeaturesCardData,
  risIconPaletteOptions,
  risIconPaletteOptionsHindi,
  RAILS_LANDING_FAQ_HINDI,
  productFeaturesCardDataHindi,
  RAILS_LANDING_CONTENT,
  RAILS_LANDING_CONTENT_HINDI,
  TRAIN_INFO_SERVICES,
  TRAIN_INFO_SERVICES_HINDI,
  TRAIN_HEADER_TITLE,
  TRAIN_HEADER_TITLE_HINDI,
  EXCLUSIVE_PARTNERS,
  EXCLUSIVE_PARTNERS_HINDI,
  LANG_ENG,
  LANG_HIN,
  LANG_STORAGE_KEY,
  RAILS_LANDING_PAGE
} from './constants/RailsLandingSeoConstants';
import { RAILS_LANDING_META_DATA } from './constants/RailsLandingSeoConstants';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import HtmlHeader from '../components/HtmlHeader';
import WhyMMTRail from './components/WhyMMTRail';
import PropTypes from 'prop-types';
import RISPalette from './components/RISpalette';
import LandingHeader from './components/LandingHeader';
import RailsLandingFooter from './components/RailsLandingFooter';
import RailsLandingContent from './components/RailsLandingContent';
import BookTrainTicket from './components/BookTrainTicket';
import RailsLandingPageAds from './components/RailsLandingPageAds';
import { FaqSection } from '../components';
import '../../styles/RailsLandingSeo.css';

const footer_data = require('./constants/railsLanding-footer-data.json');
const footer_data_hindi = require('./constants/railsLanding-footer-data-hindi.json');

const RailsLandingSeo = (props) => {
  const [lang, setLang] = useState(LANG_ENG);
  const { data } = props;

  useEffect(() => {
    let lang = null;
    try {
      lang = JSON.parse(localStorage.getItem(LANG_STORAGE_KEY));
    } catch {
      //error
    }
    if (lang) {
      setLang(lang);
    }
  }, []);

  const onClick = () => {
    if (lang === LANG_ENG) {
      setLang(LANG_HIN);
      localStorage.setItem(LANG_STORAGE_KEY, JSON.stringify(LANG_HIN));
      trackLanguageSwitch(RAILS_LANDING_PAGE, LANG_ENG, LANG_HIN);
    } else {
      setLang(LANG_ENG);
      localStorage.setItem(LANG_STORAGE_KEY, JSON.stringify(LANG_ENG));
      trackLanguageSwitch(RAILS_LANDING_PAGE, LANG_HIN, LANG_ENG);
    }
  };

  const risPalleteOptions = lang === LANG_ENG ? risIconPaletteOptions : risIconPaletteOptionsHindi;
  const productFeaturesData = lang === LANG_ENG ? productFeaturesCardData : productFeaturesCardDataHindi;
  const railsLandingFAQs = lang === LANG_ENG ? RAILS_LANDING_FAQ : RAILS_LANDING_FAQ_HINDI;
  const railsLandingContent = lang === LANG_ENG ? RAILS_LANDING_CONTENT : RAILS_LANDING_CONTENT_HINDI;
  const trainInfoServiceText = lang === LANG_ENG ? TRAIN_INFO_SERVICES : TRAIN_INFO_SERVICES_HINDI;
  const trainHeaderTitle = lang === LANG_ENG ? TRAIN_HEADER_TITLE : TRAIN_HEADER_TITLE_HINDI;
  const exclusivePartnersText = lang === LANG_ENG ? EXCLUSIVE_PARTNERS : EXCLUSIVE_PARTNERS_HINDI;
  const footer_data_json = lang === LANG_ENG ? footer_data : footer_data_hindi;

  return (
    <React.Fragment>
      <HtmlHeader data={data} />
      <div>
        <LandingHeader onClick={onClick} trainHeaderTitle={trainHeaderTitle} lang={lang} />
        <BookTrainTicket risIconPaletteOptions={risPalleteOptions} />
        <RISPalette risIconPaletteOptions={risPalleteOptions} trainInfoServiceText={trainInfoServiceText} />
        <RailsLandingPageAds exclusivePartnersText={exclusivePartnersText} />
      </div>
      <div className="LandingPageFooterBottom">
        <WhyMMTRail productFeaturesCardData={productFeaturesData} customClass="appendBottom60" />
        <RailsLandingContent railsLandingContent={railsLandingContent} />
        <div className="appendTop25">
          <FaqSection faq={railsLandingFAQs.list} title={railsLandingFAQs.title} />
        </div>
        <RailsLandingFooter footerDataJson={footer_data_json} />
      </div>
    </React.Fragment>
  );
};

RailsLandingSeo.propTypes = {
  data: PropTypes.object
};

RailsLandingSeo.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: RAILS_LANDING_META_DATA.template_name,
    meta_title: RAILS_LANDING_META_DATA.title,
    meta_description: RAILS_LANDING_META_DATA.description,
    meta_keywords: RAILS_LANDING_META_DATA.keywords,
    analytics: getStaticPageLoadEvent('mob:funnel:railsris:railsrislanding'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: RAILS_LANDING_META_DATA.h1Title,
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: ``,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };
  const pageUrl = 'https://www.makemytrip.com/railways/';
  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_RAILS-LANDING';
  return {
    pushToCache: true,
    cacheKey,
    pageType,
    pageUrl,
    ...finalResponse
  };
};

export default RailsLandingSeo;
